const VirtualServicesState = {
  data: []
}

export default VirtualServicesState
